<!-- Background Overlay -->
<div #overlay class="background-overlay" [ngClass]="{'show': isFooterExpanded}" (click)="closeMoreOptions()"></div>

<div *ngIf="isFooterExpanded" #menuContainer class="menu-container" [ngClass]="{'show': isFooterExpanded}">
  <div class="scrollable-container">
    <ion-grid>
      <ion-row>
        <ion-col size="3" size-sm="2" size-md="2.4" *ngFor="let option of moreOptions; trackBy: trackByOptionId" class="menu-item"
          [ngClass]="{'itemSelected':option.selected}" (click)="onClickMenuOption(option)">
          <div class="menu-item-content">
            <ng-container *ngIf="option.iconPath.endsWith('.svg')">
              <ion-icon class="menu-icon" *ngIf="option.selected && option.selectedIconPath"
                [src]="option.selectedIconPath"></ion-icon>
              <ion-icon class="menu-icon" *ngIf="!option.selected || !option.selectedIconPath"
                [src]="option.iconPath"></ion-icon>
            </ng-container>
            <ng-container *ngIf="!option.iconPath.endsWith('.svg')">
              <img class="menu-icon" *ngIf="option.selected && option.selectedIconPath"
                [src]="option.selectedIconPath" />
              <img class="menu-icon" *ngIf="!option.selected || !option.selectedIconPath"
                [src]="option.iconPath" />
            </ng-container>
            <span class="menu-label">{{option.displayName}}</span>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</div>
<div #footer class="navigation-footer">
  <ion-fab>
    <ion-row class="navigation-bar">
      <ng-container *ngFor="let option of footerOptions; trackBy: trackByOptionId">
        <ion-col class="menu-item" [ngClass]="{'itemSelected':option.selected}" [id]="option.id"
          role="button" tabindex="0" [attr.aria-label]="option.displayName"
          [attr.aria-current]="option.selected ? 'page' : null"
          (click)="onClickMenuOption(option)"
          (keydown.enter)="onMenuOptionKeydown($event, option)"
          (keydown.space)="onMenuOptionKeydown($event, option)">
          <div class="menu-item-content">
            <ng-container *ngIf="option.selectedIconPath; else toolIcon">
              <img class="menu-icon" alt="" *ngIf="option.selected" [src]="option.selectedIconPath" />
              <img class="menu-icon" alt="" *ngIf="!option.selected" [src]="option.iconPath" />
            </ng-container>
            <ng-template #toolIcon>
              <ion-icon class="menu-icon" aria-hidden="true" [src]="option.iconPath"></ion-icon>
            </ng-template>
            <span class="menu-label">{{option.displayName}}</span>
          </div>
        </ion-col>
      </ng-container>
    </ion-row>
  </ion-fab>
</div>
